import { computed, useSlots } from 'vue';

export function useSearchBar(search) {
  const slots = useSlots();

  const shouldRenderSearchInput = computed(() => {
    return typeof search?.value === 'string' || slots.search?.()?.component;
  });

  return { shouldRenderSearchInput };
}
